<template>
  <div class="headWrapper">
        
        <div 
            class="flexSpaceBetween"
            style="padding-left: 20px;  padding-right: 25px; padding-top: 5px;">

            <div style="text-align: center; width: 100%;">
                <router-link :to="'/'"><img src="https://raizzoncdn.b-cdn.net/home/raizzon-logo-transparent.png" width="80px" alt=""></router-link>
            </div>

        </div>

        
  </div>
</template>

<script>
export default {
    data() {
        return {
            showMenu: false
        }
    }
}
</script>

<style scoped>
a {
    color: white;
    font-size: 18px;
    font-weight: 300;
    text-decoration: none;
    padding: 5px;
}

.headWrapper {
    position: fixed;
    top: 0;
    left: 0px;
    bottom: 0;
    right: 0;
    margin: 0;
    width: 100%;
    overflow: none;
    background-color: rgba(0, 0, 0, 0.7);
    height: 80px;
    z-index: 99;
}

.subMenuWrapper {
    position: fixed; 
    top: 50px; 
    right: 25px;
    background-color: rgba(0, 0, 0, 0.7);
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 99 !important;
}

.subMenuList {
    list-style: none;    
}

.subMenuList li {
    margin-top: 10px; 
    margin-bottom: 20px;
    margin-left: -30px;
}
.subMenuList li a:hover {
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
}
</style>


// WEBPACK FOOTER //
// src/components/Header/Index.vue